import newsletters from './newsletters';

export default newsletters;



// WEBPACK FOOTER //
// ./src/pages/static/newsletters/index.jsx